import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { MuiColorInput, MuiColorInputColors } from "mui-color-input";

// Define the props for the ColorPicker component
interface Props {
  name: string;
  value: string;
  changeColor: (value: string, colors: MuiColorInputColors) => void;
  outline: "right" | "left";
}

// Define the ColorPicker functional component
const ColorPicker: FC<Props> = ({ name, outline, value, changeColor }) => {
  return (
    <Box
      className="colorPick"
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        mt: 2,
        mr: outline === "right" ? 0 : 2,
        ml: outline === "left" ? 0 : 2,
      }}
    >
      <Box flex={"50%"}>
        <Typography textAlign={"left"}>{name}</Typography>
      </Box>
      <Box flex={"50%"}>
        <MuiColorInput
          format="hex"
          value={value}
          onChange={changeColor}
          required={false}
        />
      </Box>
    </Box>
  );
};

export default ColorPicker;
